module.exports = __webpack_public_path__ + "img/bg-profile.9af971bf.jpg";